/* eslint-disable @typescript-eslint/no-explicit-any */
import { AutocompleteItem, Autocomplete as AutocompleteNextUI, Spinner } from '@nextui-org/react';
import React from 'react';

import { Asterisk } from '@phosphor-icons/react';

export interface IOptions {
  label: string;
  value: string | number;
  description?: string;
}

export interface AutocompleteCustomProps {
  options: IOptions[];
  label?: string;
  required?: boolean;
  selectionMode?: 'none' | 'single' | 'multiple';
  size?: 'lg' | 'sm' | 'md' | undefined;
  radius?: 'none' | 'lg' | 'sm' | 'md' | 'full' | undefined;
  id?: string;
  name?: string;
  value?: any;
  onChange?: any;
  isInvalid?: boolean;
  errorMessage?: string;
  placeholder?: string;
  defaultSelectedKey?: string;
  inputValue?: any;
  onInputChange?: any;
  onSelectionChange?: any;
  defaultInputValue?: string;
  selectedKey?: any;
  onValueChange?: any;
  isLoading?: boolean;
}

const Autocomplete: React.FC<AutocompleteCustomProps> = ({
  label,
  required,
  selectionMode,
  options,
  isInvalid,
  onChange,
  id,
  name,
  value,
  onSelectionChange,
  radius,
  placeholder,
  selectedKey,
  defaultSelectedKey,
  onInputChange,
  onValueChange,
  defaultInputValue,
  inputValue,
  size,
  errorMessage,
  isLoading,
  ...props
}) => {
  return (
    <div className='w-full'>
      {label && (
        <div className='mb-[6px] flex gap-1'>
          <div className='text-primary font-medium text-sm'>{label}</div>
          {required && <Asterisk size={10} color='#D92D20' weight='bold' className='mt-[2px]' />}
        </div>
      )}

      <AutocompleteNextUI
        variant='bordered'
        name={name}
        value={value}
        id={id}
        onValueChange={(value) => {
          if (onValueChange) {
            onValueChange(value);
          }
        }}
        // inputValue={valueChangeInput}
        defaultInputValue={defaultInputValue}
        selectedKey={selectedKey}
        defaultSelectedKey={defaultSelectedKey}
        onSelectionChange={(e) => {
          if (onSelectionChange) {
            onSelectionChange(e);
          }
        }}
        placeholder={placeholder}
        onChange={onChange}
        onInputChange={(e) => {
          if (onInputChange) {
            onInputChange(e);
          }
        }}
        isInvalid={isInvalid}
        errorMessage={errorMessage}
        size={size}
        radius={radius}
        className='auto-complete'
        classNames={{
          clearButton: ['text-secondary text-[12px]'],
        }}
        endContent={isLoading ? <Spinner size='sm' color='secondary' /> : undefined}
        {...props}
      >
        <>
          {options?.length > 0 ? (
            options.map((item) => (
              <AutocompleteItem
                classNames={{
                  selectedIcon: ['text-bg-brand-solid'],
                  base: [
                    'data-[hover=true]:!bg-bg-secondary  data-[focus-visible=true]:!outline-none',
                  ],
                  title: ['text-primary'],
                }}
                key={item?.value}
                value={item?.value}
              >
                {item?.label}
              </AutocompleteItem>
            ))
          ) : (
            <AutocompleteItem key='no-results' isReadOnly>
              {isLoading ? 'Loading...' : 'No results found'}
            </AutocompleteItem>
          )}
        </>
      </AutocompleteNextUI>
    </div>
  );
};

export default Autocomplete;
